export default __webpack_public_path__ + "static/opt-4-91f3cde183fd1080df187d227228bc4d.webp";